const isAurretikPage = url => /^\/(es|eu)\/[Aa]urretik$/.test(url)

export default isAurretikPage